package fr.frux.core.designsystem.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.theme.FruxSpacing

/**
 * En-tête « grand titre » des écrans d'onglet (mock frux-design, décision Fred 2026-08-09) :
 * titre gras aligné à gauche (Sora, `headlineLarge`) avec sous-titre optionnel en dessous,
 * remplace la top bar centrée sur les écrans racines de la navigation par onglets (Carte,
 * Cueillettes, Favoris, Profil). Les écrans poussés (flèche retour) gardent [FruxTopBar].
 *
 * Ne gère pas l'inset `statusBars` : sur les écrans qui l'utilisent aujourd'hui, ce padding est
 * déjà porté par le `Scaffold` appelant (contentPadding par défaut incluant les barres système,
 * cf. `ProfileScreen` qui n'a jamais eu de top bar) — l'appelant doit vérifier qu'il ne passe pas
 * sous l'heure système si ce n'est pas déjà le cas.
 */
@Composable
fun FruxScreenHeader(
    title: String,
    modifier: Modifier = Modifier,
    subtitle: String? = null,
) {
    Column(
        modifier = modifier
            .padding(horizontal = FruxSpacing.md)
            .padding(top = FruxSpacing.lg, bottom = FruxSpacing.sm),
    ) {
        Text(
            text = title,
            style = MaterialTheme.typography.headlineLarge,
            color = MaterialTheme.colorScheme.onBackground,
        )
        if (subtitle != null) {
            Text(
                text = subtitle,
                style = MaterialTheme.typography.bodyLarge,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.padding(top = FruxSpacing.xs),
            )
        }
    }
}
